<template>
  <v-container>
    <template v-if="viewDataIsLoaded">
      <!--app-view-toolbar-->
      <app-view-toolbar :title="companyName" :showBackButton="true" backRoute="company-dashboard" :isEdit="false">
      </app-view-toolbar>
      <v-alert
        type="info"
      >
        Här kan du skapa olika kombinationer av kvalifikationer i form av chaufförsprofiler, som du sedan kan använda när du lägger upp dina jobb.
      </v-alert>
      <template>
        <!--qualification presets-->
        <div class="d-flex justify-space-between align-center">
          <div class="text-h6">Chaufförsprofiler</div>
          <div>
            <v-btn
              color="secondary"
              small
              text
              class="mt-3 mb-2 ml-2"
              @click="addNewQualificationPreset()"
            >
              <v-icon left>mdi-plus</v-icon>
              Lägg till
            </v-btn>
          </div>
        </div>
        <v-data-table
          :headers="viewData.qualificationPresetListData.listData.header_ar"
          :items="viewData.qualificationPresetListData.listData.item_ar"
          :items-per-page="viewData.qualificationPresetListData.itemsPerPage"
          :hide-default-header="viewData.qualificationPresetListData.listData.item_ar.length == 0"
          :hide-default-footer="viewData.qualificationPresetListData.listData.item_ar.length == 0"
          @click:row="editQualificationPreset"
          class="xClickRowTable"
        >
          <template v-slot:no-data>
            <div class="text-left">
              {{ txtNoTableData }}
            </div>
          </template>
        </v-data-table>
      </template>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'QualidficationPreset',
  components: {
    'app-snack-bar': SnackBar,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      refreshTimeout: null,
      viewDataIsLoaded: false,
      viewData: {},
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData', 'isGreen']),
    companyName() {
      return this.loggedInData.agentData.name
    },
    txtNoTableData() {
      return this.viewDataIsLoaded ? 'Inga finns' : 'Hämtar data...'
    }
  },
  methods: {
    doOnViewData(returnData) {
      this.viewData = returnData
      this.viewDataIsLoaded = true
    },
    addNewQualificationPreset() {
      this.loadQualificationPreset(0)
    },
    editQualificationPreset(value) {
      this.loadQualificationPreset(value.id)
    },
    loadQualificationPreset(id) {
      this.$router.push({ name: 'qualification-preset-edit', params: { id: id } })
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/company/qualification-preset-list/' + this.loggedInData.agentData.id)
//      console.log('get', url)
      axios.get(url, config)
        .then(response => {
//          console.log('response', response)
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    }
  },
  created() {
    //get viewData
    this.loadViewData()
  },
  destroyed() {
  }
}
</script>

<style>
</style>